// extracted by mini-css-extract-plugin
export default {"SASDetailsTable":"lKdtWE2I4iNOhtjB4HX7","SASFootPrintContainerTable":"sCwLdmSbmZvjm3UGmEBf"};